import { Component as BrComponent, Page } from '@bloomreach/spa-sdk';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CardContent, CardLinkClickEvent, PageSectionContent } from '@types';
import { SectionComponent } from '../section-component.interface';
import { ResponsiveService } from '@frk/eds-components';
import { Observable } from 'rxjs';
import { TitleTheme } from '@frk/eds-components';
import { CardsService } from '@services/cards.service';
import { Logger } from '@utils/logger';
import { WidenService } from '@services';

const logger = Logger.getLogger('ThumbnailsSectionComponent');

@Component({
  selector: 'ft-thumbnails-section',
  templateUrl: './thumbnails-section.component.html',
  styleUrls: ['./thumbnails-section.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ThumbnailsSectionComponent implements SectionComponent {
  /**
   * Bloomreach component
   */
  component: BrComponent;

  /**
   * Bloomreach page model
   */
  page: Page;

  /**
   * Page Section content
   */
  content: PageSectionContent;

  /**
   * Display type
   */
  sectionType: string;

  /**
   * Cards Array
   */
  cards: Array<CardContent>;

  /**
   * Theme
   */
  theme: string;

  /** Footnote for section block */
  footnote: string;

  public hasContainerWide = false;

  titleColorTheme: TitleTheme = 'basic';

  isHandheld$: Observable<boolean>;

  colsPerGridForDesktop = 2;

  PDF_ICON_PATH = '/assets/icons/file-icons/ft-global-icon-pdf.svg';
  PREVIEW_ICON_PATH = '/assets/icons/file-icons/pdf-preview.png';

  constructor(
    private responsiveService: ResponsiveService,
    private cardsService: CardsService,
    private widenService: WidenService
  ) {}

  /**
   * Populate the component
   * @param component - A parameter
   * @param page - A parameter
   * @param content - A parameter
   */
  populate(
    component: BrComponent,
    page: Page,
    sectionType: string,
    content: PageSectionContent,
    theme: string
  ) {
    this.component = component;
    this.page = page;
    this.sectionType = sectionType;
    this.content = content;
    this.titleColorTheme =
      this.component?.getParameters()?.titleColor || 'basic';
    this.hasContainerWide = this.component?.getParameters()?.hasContainerWide;
    if (this.content?.cards) {
      this.cards = this.cardsService.formatCardURL(
        this.cardsService.formatCards(this.content?.cards as CardContent[]),
        this.page
      );
      this.colsPerGridForDesktop = this.calculateCardsPerRow(
        this.cards?.length
      );
      this.theme = theme || 'primary';
    }
    this.isHandheld$ = this.responsiveService.isHandheld$();
    if (this.cards) {
      this.setDynamicThumbnails(this.cards);
    }
    this.footnote = this.content.footnote?.value;
  }

  /**
   * Implement cards per row based on WDE-1070
   * @param cardsLength Length of the cards
   * @returns cards per row
   */
  private calculateCardsPerRow(cardsLength: number): number {
    if (cardsLength % 3 === 0 || cardsLength > 4) {
      return 3;
    } else if (cardsLength <= 4 && cardsLength !== 1) {
      return 2;
    } else {
      return cardsLength;
    }
  }

  public setDynamicThumbnails(cards: Array<CardContent>) {
    for (const card of cards) {
      logger.debug(card.link?.widenAssetCompound);
      if (card.eventParams?.embed_id) {
        // As this is a thumbnail component - let's get the document thumbnail from widen
        card.imgSrc = this.widenService.getThumbnailUrl(
          card.eventParams?.embed_id
        );
      }
    }
  }

  setDownloadLocation(event: CardLinkClickEvent) {
    this.cardsService.setDownloadLocation(event);
  }
}
